<primecontrol-modal-body>
  <div class="overflow-y-auto flex flex-col flex-1 min-h-0 px-6 py-4 gap-4">
    <!-- Name -->
    <primecontrol-input
      [control]="instanceForm.controls['name']"
      [label]="'NAME' | translate"
    ></primecontrol-input>

    <!-- Description -->
    <primecontrol-textarea
      [control]="instanceForm.controls['description']"
      [label]="'DESCRIPTION' | translate"
      [rows]="3"
    ></primecontrol-textarea>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <!-- Country -->
      <primecontrol-select
        [control]="instanceForm.controls['countryIso']"
        [label]="'COUNTRY' | translate"
        [options]="countries"
      ></primecontrol-select>

      <!-- Currency -->
      <primecontrol-select
        [control]="instanceForm.controls['defaultCurrency']"
        [label]="'CURRENCY' | translate"
        [options]="currencies()"
      ></primecontrol-select>

      <!-- Default Language -->
      <primecontrol-select
        [control]="instanceForm.controls['defaultLanguage']"
        [label]="'DEFAULT_LANGUAGE' | translate"
        [options]="languages"
        [placeholder]="'SELECT_LANGUAGE' | translate"
      ></primecontrol-select>

      <!-- Timezone: starts on the browser's, the picker changes it -->
      <primecontrol-select
        [control]="instanceForm.controls['timeZoneReference']"
        [label]="'TIMEZONE' | translate"
        [text]="instanceForm.get('timeZoneReference')?.value"
        [placeholder]="'SELECT_TIMEZONE' | translate"
        (change)="openTimeZone()"
        [type]="'button'"
      ></primecontrol-select>
    </div>
  </div>
</primecontrol-modal-body>

<primecontrol-modal-footer>
  <div class="flex items-center min-h-16 gap-3 justify-end">
    <primecontrol-button
      [label]="'CANCEL'"
      [icon]="'mat_solid:close'"
      [type]="'outline'"
      [hideOnMobile]="true"
      (event)="close()"
      [color]="'secondary'"
    ></primecontrol-button>
    <primecontrol-button
      [label]="'SAVE'"
      [icon]="'heroicons_solid:check'"
      [loading]="isSaving()"
      [hideOnMobile]="true"
      (event)="save()"
      [disabled]="instanceForm.invalid || isSaving()"
      [color]="'primary'"
    ></primecontrol-button>
  </div>
</primecontrol-modal-footer>
